// @ts-nocheck
// TODO: tighten types after migration
import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const SafariBottomBar = () => {
    const location = useLocation();
    const [isMobileSafari, setIsMobileSafari] = useState(false);
    const [isAudioPlaying, setIsAudioPlaying] = useState(false);

    useEffect(() => {
        const ua = window.navigator.userAgent;
        const isIPhone = /iPhone|iPod/i.test(ua);
        const isiPad = /iPad/i.test(ua);

        // All iOS browsers on iPhone (Safari, Chrome iOS, Firefox iOS, Brave, Edge, DuckDuckGo, etc.)
        // all use WebKit and show the "Now Playing" bar at the bottom when audio is playing
        if (isIPhone && !isiPad) {
            setIsMobileSafari(true);
        }
    }, []);

    useEffect(() => {
        const handlePlayingChange = (e) => {
            setIsAudioPlaying(e.detail && e.detail.isPlaying);
        };
        window.addEventListener('audioPlayingChange', handlePlayingChange);
        return () => window.removeEventListener('audioPlayingChange', handlePlayingChange);
    }, []);

    if (!isMobileSafari || !isAudioPlaying) return null;

    const isContactPage = location.pathname === '/contact';

    return (
        <div
            className="fixed bottom-0 left-0 right-0 h-[5px] border-t-2 border-[var(--slider-text)] bg-[var(--bg-color)] z-[99999] pointer-events-none"
            style={{
                transform: 'translateZ(0)',
                clipPath: 'inset(0 0 0 0)',
                ...(isContactPage ? { backgroundColor: 'transparent', borderTop: 'none' } : {})
            }}
        />
    );
};

export default SafariBottomBar;
